<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      四联站<br>
站点介绍
四联站位于红棉路与横岗一号路、恒心路交叉口，沿红棉路东西向布置，车站东北侧为新城汇商场，西北侧临近康乐幼儿园，西南侧临近信义锦绣花园，南侧康乐五区。东接坳背站，西接六约北站。车站充分体现“阳光+”生长的线路主题，色彩提炼树干暖色调突显向上生长的空间张力，以及提炼枝繁叶茂的浅绿色系展现生态与阳光的完美结合。整体空间通过“白色”“木色”、“绿色系”进行组合，在满足线网“阳光+”的同时，色彩的搭配体现车站阳光+生长绿意盎然的生态特色主题空间。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:35	23:34	14号线	4分30秒	6分15秒<br>
沙田	06:21	23:51	14号线	4分30秒	6分15秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:34	23:34	14号线	5分25秒	6分15秒<br>
沙田	06:21	23:51	14号线	5分25秒	6分15秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:34	00:34	14号线	5分钟	6分15秒<br>
沙田	06:21	00:51	14号线	5分钟	6分15秒<br><br>

站点出口信息<br><br>
A出入口:<br>
横岗一号路东侧、信义锦绣花园、卓越城市中心花园<br><br>
B出入口:<br>
红棉路南侧（西）、康乐五区<br><br>
C出入口:<br>
红棉路南侧（东）、贤合小区<br><br>
E1出入口:<br>
红棉路北侧、龙岗区横岗街道职工新村、康乐花园、康乐幼儿园、怡锦社区党群服务中心（办事大厅）<br><br>
E2出入口:<br>
恒心路西侧、怡锦社区退役军人服务站<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 横岗文体广场<br>
大梅沙假日专线2号、M570、M466、M229、906<br><br>
E1出入口:<br>
公交站名： 康乐花园幼儿园<br>
M229<br><br>
E2出入口:<br>
公交站名： 康乐学校<br>
M229、906、M570、M208、B953<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shisihaoxian",
            title: "14号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>